import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import useCategories from 'Hooks/useCategories';
import useTaxonomies from 'Hooks/useTaxonomies';
import Skeleton from 'Components/Atoms/Skeleton/Skeleton';
import SelectSingleTagSingleTaxonomy from './SelectSingleTagSingleTaxonomy';
import SelectSingleTagMultipleTaxonomies from './SelectSingleTagMultipleTaxonomies';

const SelectSingleTag = forwardRef(function SelectSingleTag(props, ref) {
    const { ...selectProps } = props;

    const { taxonomies, isLoading: isLoadingTaxonomies } = useTaxonomies();
    const { categories, isLoading: isLoadingCategories } = useCategories();

    const isLoading = isLoadingCategories || isLoadingTaxonomies;
    const hasMultiTaxonomies = taxonomies.length > 1;

    if (isLoading) return <Skeleton variant="rectangular" />;

    if (hasMultiTaxonomies) {
        return (
            <SelectSingleTagMultipleTaxonomies
                categories={categories}
                taxonomies={taxonomies}
                ref={ref}
                {...selectProps}
            />
        );
    }

    return <SelectSingleTagSingleTaxonomy categories={categories} ref={ref} {...selectProps} />;
});

export default SelectSingleTag;

SelectSingleTag.propTypes = {
    disabled: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    className: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    highlight: PropTypes.bool,
};


